<div class="separator">
  <ng-content></ng-content>
</div>
